<section>
    <div>
        <p class="bolt-heading-sm bolt-space-bottom-lg">Document and photo file requirements</p>
        <p class="bolt-body-copy-lg bolt-space-bottom-lg">Each claim has a limit of 20 supporting files. When you share
            something with us, make sure it:</p>
        <ul class="bolt-space-bottom-lg">
            <li class="bolt-body-copy-lg">Is 10 MB or less</li>
            <li class="bolt-body-copy-lg">Doesn’t have special characters in the file name</li>
            <li class="bolt-body-copy-lg">Is a document file (pdf, word), image, video or spreadsheet</li>
        </ul>
        <p class="bolt-body-copy-lg bolt-space-bottom-lg">Talk to your claims professional to share something that doesn’t
            meet these requirements.</p>

        <is-nw-box-uploader
            [uploadCompleteEmitter]="uploadCompleteEmitter"
            [claimDetails]="claimDetails">
        </is-nw-box-uploader>
        <bolt-notification *ngIf="fileUploaded"
            type="info">
            New documents take up to an hour to appear in your list of uploaded documents. <a href="javascript:void(0)" (click)="refreshDocuments()">Refresh</a> the list or check back
            later.
        </bolt-notification>
        <br>
    </div>
</section>
